"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractService2 = _interopRequireDefault(require("../../AbstractService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * This class handles login for NIF markets.
 */
var NifAuthService = /*#__PURE__*/function (_AbstractService) {
  _inherits(NifAuthService, _AbstractService);

  var _super = _createSuper(NifAuthService);

  /**
   * Class constructor.
   */
  function NifAuthService() {
    _classCallCheck(this, NifAuthService);

    return _super.call(this);
  }
  /**
   * Fetches and returns user data.
   *
   * @param {object} config Configuration.
   * @param {object[]} config.endpoints Enable e-commerce api (true/false).
   * @returns {Promise} Promise object.
   */


  _createClass(NifAuthService, [{
    key: "getUser",
    value: function getUser(config) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        fetch(_this._getContextUrl(config), {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          },
          credentials: 'include'
        }).then(_this._handleResponse.bind(_this)).then(resolve).catch(_this._rejectWrapper.bind(_this, reject));
      });
    }
    /**
     * Returns the /context URL.
     *
     * @param {object} config Configuration.
     * @param {object[]} config.endpoints Enable e-commerce api (true/false).
     * @returns {string} Url.
     */

  }, {
    key: "_getContextUrl",
    value: function _getContextUrl(config) {
      return "".concat(config.endpoints.nifECommerceApiEndpoint, "/context");
    }
    /**
     * Returns the name used by ServiceFactory.
     *
     * @override
     * @returns {string} Factory name.
     */

  }], [{
    key: "factoryName",
    get: function get() {
      return 'nifauth';
    }
  }]);

  return NifAuthService;
}(_AbstractService2.default);

exports.default = NifAuthService;